import { formatPLN } from "../finance";
import {
  COLLECTION_CONTRIBUTION_MODE,
  getCollectionContributionConfig,
} from "./contributionConfig";

export const ACTIVE_COLLECTION_DESCRIPTION_FALLBACK = "Aktywna zbiórka";
export const ACTIVE_COLLECTION_SECTION_SUBTITLE =
  "Podgląd aktualnej zbiórki i zebranych wpłat";

export function getActiveCollectionDescription(collection = {}) {
  return collection?.description || ACTIVE_COLLECTION_DESCRIPTION_FALLBACK;
}

export function getCollectionPresentation(collection = {}) {
  collection = collection || {};
  const contribution = getCollectionContributionConfig(collection);
  const currentAmount = Number(collection.current_amount ?? 0);
  const targetAmount =
    collection.target_amount === null || collection.target_amount === undefined
      ? null
      : Number(collection.target_amount);
  const hasOverallTarget = Number.isFinite(targetAmount) && targetAmount > 0;
  const isFlexibleRange =
    contribution.contributionMode ===
    COLLECTION_CONTRIBUTION_MODE.FLEXIBLE_RANGE;

  return {
    ...contribution,
    currentAmount,
    targetAmount: hasOverallTarget ? targetAmount : null,
    hasOverallTarget,
    isFlexibleRange,
    progress: hasOverallTarget
      ? Math.max(0, Math.min(100, (currentAmount / targetAmount) * 100))
      : null,
    missing: hasOverallTarget
      ? Math.max(0, targetAmount - currentAmount)
      : null,
    contributionLabel: isFlexibleRange
      ? `Dowolna wpłata: ${formatPLN(contribution.minContribution)}–${formatPLN(contribution.maxContribution)}`
      : null,
    affectsClassBalance: collection.affects_class_balance !== false,
  };
}

export function formatCollectionDate(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value ?? ""));
  return match ? `${match[3]}.${match[2]}.${match[1]}` : null;
}
